import { render } from "./EditAgentPopup.vue?vue&type=template&id=29e79754"
import script from "./EditAgentPopup.vue?vue&type=script&lang=js"
export * from "./EditAgentPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__